/*

addNewConstellationGroup  Assigns a new group number and creates a default constellation of one GEO satellite. Returns new group number.
configureConstellationAsGEOfullArc(iG:number, spacing:number)    Configures or reconfigures one group
forceGEO(iG:number, longitudes:Array<number>)       Sets orbit parameters to exactly GEO
configureConstellationAsOWplanes(iG:number, RAANlist:Array<number>)
configureConstellationAsOneOWplane(iG:number, nSatellites:number, MAoffset_deg:number, Raan_deg:number)
configureConstellationAsNominalFullOneWebGroup(iG:number)
configureConstellationAsListOfGEOs( iG:number, longitudes:Array<number>, names:Array<string>)
configureConstellationAsLEO(iG:number, nPlanes, nSatellitesPerPlane, inclination_deg, apogeeHeight_km, perigeeHeight_km )

The following are now obsolete:
The following functions create a group of satellites and return a new group number
addOWplane(nSatellites, MAoffset_deg, Raan_deg)
addOWplanes(RAANlist)
addNominalFullOneWebGroup()
addGEOgroup( longitudes, names)
addGEOfullArc(spacing)
addEllipticalPlanes(nPlanes, nSatellitesPerPlane, inclination_deg, apogeeHeight_km, perigeeHeight_km )

// The following set properties of the whole group, or a list of sat numbers within the group.
colorGroup(n, color:string, list?)  
blinkGroup
styleGroup
RAANGroup
meanMotionGroup
inclinationGroup

showGroup(n, show:boolean)  // Show or hide whole group
setSize(iG:number, size:number, list?:Array<number>)   // Set size of all sats in group n. Default all, or just the indices in list
makeBlink(n, list?)  // Set blinking = true for all sats in group n. Default all, or just the indices in list
makeSteady(n, list?)  // Set blinking = for for all sats in group n. Default all, or just the indices in list
getInclinedList(iG, minIncl, maxIncl) // Returns array list of indices of iG that are within the min and max incl values

getNSatsInGroup

*/


import UtilSP from "SATPROF_UTILS/UtilSP"; 
//import THREE from 'THREE_BOOTSTRAP'; //This causes problems
import * as THREE from 'three';
import RandomWithSeed from "SATPROF_UTILS/RandomWithSeed";
import { Spherical } from "three";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import Satellite3D2_grp from "SATPROF_LIBRARY/ThreeDParts/Satellite3D2_grp";
//import Satellite3D_grp from "SATPROF_LIBRARY/ThreeDParts/Satellite3D_grp";
import OneWebSatellite_grp from "SATPROF_LIBRARY/ThreeDParts/OneWebSatellite_grp";

export default class Constellations3_grp  extends THREE.Group{
    public satSize:number = 200;
    //public satellite_g:THREE.BoxGeometry;
    //public green_mat:THREE.MeshBasicMaterial;
    //public red_mat:THREE.MeshBasicMaterial;
    //public blue_mat:THREE.MeshBasicMaterial;
    //public yellow_mat:THREE.MeshBasicMaterial;
    public satelliteParams:Array<Array<any>>;
    public _secondsSinceMasterEpoch:number = 0;
    public paramsObj:any;
    public satObject:Array<Array<any>>;
    //public geometries:Array<Array<THREE.BoxGeometry>>;
    public satSprite:Array<Array<THREE.Sprite>>;
    private _nGroups:number = 0;
    public filter:Array<any>;
    public objectType:Array<string>; // "cube"  "OWdetailed"
    private blinkTimer:TimingInfo;
    private _starsGroup:THREE.Group;
    public maxGroups = 20;
    public orbitPlaneDisc_g:THREE.CircleGeometry;
    public orbitPlaneDisc_mat:THREE.MeshBasicMaterial;
    public orbitPlaneDisc_m:THREE.Mesh;
    public orbitPlaneDisc1:THREE.Group;
    public orbitPlaneDisc2:THREE.Group;
    public cosmicAxes:THREE.AxesHelper;
    public cosmicPlane_g:THREE.PlaneGeometry;
    public cosmicPlane_mat:THREE.MeshBasicMaterial;
    public cosmicPlane_m:THREE.Mesh;
 
    constructor(){
        super();
        //var group1 = new THREE.Group();
        console.log("In Constellations3_grp constructor ");

        this.orbitPlaneDisc1 = new THREE.Group();
        this.orbitPlaneDisc2 = new THREE.Group();
        this.orbitPlaneDisc_g = new THREE.CircleGeometry(10000, 64);
        this.orbitPlaneDisc_mat = new THREE.MeshBasicMaterial({color:"white",transparent:true, opacity:0.5, side: THREE.DoubleSide});
        this.orbitPlaneDisc_m = new THREE.Mesh(this.orbitPlaneDisc_g, this.orbitPlaneDisc_mat);
        this.orbitPlaneDisc1.add(this.orbitPlaneDisc_m);
        this.orbitPlaneDisc2.add(this.orbitPlaneDisc1);
        this.add(this.orbitPlaneDisc2);
        this.orbitPlaneDisc_m.rotation.x = Math.PI/2;
        this.setOrbitPlaneDisc(0, 0, 10000);

        this.cosmicPlane_g = new THREE.PlaneGeometry(500000, 500000);
        this.cosmicPlane_mat = new THREE.MeshBasicMaterial({color:"red",transparent:true, opacity:0.5, side: THREE.DoubleSide});
        this.cosmicPlane_m = new THREE.Mesh(this.cosmicPlane_g, this.cosmicPlane_mat);
        this.cosmicPlane_m.rotation.x = Math.PI/2;
        this.add(this.cosmicPlane_m);


        this.cosmicAxes = new THREE.AxesHelper(15000);
        this.add(this.cosmicAxes);
        this.showCosmicAxes = false;

        // this.satellite_g = new THREE.BoxGeometry(this.satSize,this.satSize,this.satSize);
        // this.green_mat = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
        // this.red_mat = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
        // this.blue_mat = new THREE.MeshBasicMaterial( { color: 0x0000ff } );
        // this.yellow_mat = new THREE.MeshBasicMaterial( { color: 0xffff00 } );

        this.blinkTimer = new TimingInfo();
        this.blinkTimer.reset();

        this._secondsSinceMasterEpoch = 0;
        this.paramsObj = {};
        this.filter = [];
        this.satelliteParams = [];
        this.satObject = [];
        this.satSprite = [];
        //this.geometries = [];
        this.objectType = [];
        for (let i:number = 0; i<this.maxGroups; i++){
            this.objectType[i] = "cube"; //"cube";  "detailed"
        }

        this._starsGroup = new THREE.Group();
        this.add(this._starsGroup);
        this.createStars();
        this.clearAll();
        this.updatePositions(); // Moves meshes around per Kepler's law
        this.showOrbitPlaneDisc = false;
        this.showCosmicPlane = false;
        //this.listSatellites();
        let constellationHelper:THREE.AxesHelper = new THREE.AxesHelper( 50000 );
        this.add( constellationHelper );        
        console.log("Exiting constellations3_grp constructor");


    }
    public clearAll(){
        this.clearGeometriesAndMeshes();
        this.satelliteParams = [];

    }
    //public addGEOgroup( longitudes:Array<number>, names:Array<string>):number{
    public configureConstellationAsListOfGEOs( iG:number, longitudes:Array<number>, names:Array<string>):void{
        // Make a group of non-inclined satellites
        this.satelliteParams[iG] = [] ;
        //debugger;
        let MM = UtilSP.solarDay_sec/UtilSP.siderealDay_sec;  // Mean motion = rev per sideral day

        for (var i=0; i<longitudes.length; i++){
            this.satelliteParams[iG][i] = {};
            this.satelliteParams[iG][i].objectName = names[i];
            this.satelliteParams[iG][i].color = "red"; // Nominal
            this.satelliteParams[iG][i].satSize = 200; // Nominal
            this.satelliteParams[iG][i].blinking = false; // Nominal
            this.satelliteParams[iG][i].visible = true; // Nominal
            this.satelliteParams[iG][i].type = "generic"; // Nominal
            this.satelliteParams[iG][i].incl_deg = 0;
            this.satelliteParams[iG][i].e = 0;
            this.satelliteParams[iG][i].Raan_deg = 0;
            this.satelliteParams[iG][i].AOP_deg = 0;
            this.satelliteParams[iG][i].MAatEpoch_deg = longitudes[i] + 90;//Empirical to match Earth1; 
            this.satelliteParams[iG][i].MM_rpd = MM;
            this.satelliteParams[iG][i].Te_sec = 0;            
            this.satelliteParams[iG][i].GEOlongitude = longitudes[i];            
            this.satelliteParams[iG][i].isGEO = true;  

            //debugger;
            //let v:THREE.Vector3 = UtilSP.keplerOrbitTLE( 0, this.satelliteParams[iG][i]);
            //console.log("vector = "+UtilSP.vector3toString(v));  
            //let az = UtilSP.degrees(Math.atan2(v.z, v.x))
            //console.log("i = "+i+", az = "+az+", MM = "+MM)          
        }
        this.forceGEO(iG, longitudes);
        this.loadGroup(iG);  
    }
    // public addGEOfullArc(spacing:number):number{
    //     let iGnew = this.addNewConstellationGroup();
    //     this.configureConstellationAsGEOfullArc(iGnew, spacing);
    //     return iGnew;
    // }
  
    public configureConstellationAsGEOfullArc(iG:number, spacing:number){
        //let iG:number;
        // let existingGroup:boolean;
        // if (typeof existingGroupNumber !== 'undefined'){
        //     iG = existingGroupNumber;
        //     existingGroup = true;
        // } else {
        //     iG = this._nGroups - 1; // Add to the end
        //     this._nGroups ++;
        //     existingGroup = false;
        // }
        this.satelliteParams[iG] = [] ;
        let nLongitudes:number = Math.floor(360 / spacing);
        let long:number;
        let MM = UtilSP.solarDay_sec/UtilSP.siderealDay_sec;  // Mean motion = rev per sideral day
        for (let i=0; i<nLongitudes; i++){
            long = i * spacing;
            this.satelliteParams[iG][i] = {};
            this.satelliteParams[iG][i].objectName = "Sat"+i;
            this.satelliteParams[iG][i].color = "red"; // Nominal
            this.satelliteParams[iG][i].satSize = 200; // Nominal
            this.satelliteParams[iG][i].blinking = false; // Nominal
            this.satelliteParams[iG][i].visible = true; // Nominal
            this.satelliteParams[iG][i].type = "generic"; // Nominal
            this.satelliteParams[iG][i].incl_deg = 0;
            this.satelliteParams[iG][i].e = 0;
            this.satelliteParams[iG][i].Raan_deg = 0;
            this.satelliteParams[iG][i].AOP_deg = 0;
            this.satelliteParams[iG][i].MAatEpoch_deg = long + 90;//Empirical to match Earth1; 
            this.satelliteParams[iG][i].MM_rpd = MM;
            this.satelliteParams[iG][i].Te_sec = 0;            
            this.satelliteParams[iG][i].GEOlongitude = long;            
            this.satelliteParams[iG][i].isGEO = true;  
        }
        console.log("In configureConstellationAsGEOfullArc, loading group "+iG+", "+nLongitudes+" satellites, spacing = "+spacing);
        this.loadGroup(iG);  
    }
    public addNewConstellationGroup():number{

        let iG:number;
        this._nGroups ++;
        iG = this._nGroups - 1; // Add to the end
        //console.log("In addNewConstellationGroup, iG = "+iG);
        this.satelliteParams[iG] = [] ;
        //debugger;
        let MM = UtilSP.solarDay_sec/UtilSP.siderealDay_sec;  // Mean motion = rev per sideral day
        let longitudes:Array<number> = [0];

        this.satelliteParams[iG][0] = {};
        this.satelliteParams[iG][0].objectName = "Default sat";
        this.satelliteParams[iG][0].color = "red"; // Nominal
        this.satelliteParams[iG][0].satSize = 20000; // Nominal
        this.satelliteParams[iG][0].blinking = false; // Nominal
        this.satelliteParams[iG][0].visible = true; // Nominal
        this.satelliteParams[iG][0].type = "generic"; // Nominal
        this.satelliteParams[iG][0].incl_deg = 0;
        this.satelliteParams[iG][0].e = 0;
        this.satelliteParams[iG][0].Raan_deg = 0;
        this.satelliteParams[iG][0].AOP_deg = 0;
        this.satelliteParams[iG][0].MAatEpoch_deg = longitudes[0] + 90;//Empirical to match Earth1; 
        this.satelliteParams[iG][0].MM_rpd = MM;
        this.satelliteParams[iG][0].Te_sec = 0;            
        this.satelliteParams[iG][0].GEOlongitude = longitudes[0];            
        this.satelliteParams[iG][0].isGEO = true;  
        
        this.forceGEO(iG, longitudes);
        this.loadGroup(iG);         
        return iG;
    }
    public forceGEO(iG:number, longitudes:Array<number>){
        let MM = UtilSP.solarDay_sec/UtilSP.siderealDay_sec;  // Mean motion = rev per sideral day
        for (var i=0; i<longitudes.length; i++){

            this.satelliteParams[iG][i].incl_deg = 0;
            this.satelliteParams[iG][i].e = 0;
            this.satelliteParams[iG][i].Raan_deg = 0;
            this.satelliteParams[iG][i].AOP_deg = 0;
            this.satelliteParams[iG][i].MAatEpoch_deg = 90 + longitudes[i]; //// + 90;//Empirical to match Earth1; 
            this.satelliteParams[iG][i].MM_rpd = MM;
            this.satelliteParams[iG][i].Te_sec = 0;
            this.satelliteParams[iG][i].isGEO = true;  
            this.satelliteParams[iG][i].GEOlongitude = longitudes[i];            

            //debugger;
            //let v:THREE.Vector3 = UtilSP.keplerOrbitTLE( this.satelliteParams[iG][i].Te_sec, this.satelliteParams[iG][i]);
            //console.log("vector = "+UtilSP.vector3toString(v));  
            //let az = UtilSP.degrees(Math.atan2(v.z, v.x))
            //console.log("i = "+i+", az = "+az+", MM = "+MM)          
        }    
    
    }


    //public addNominalFullOneWebGroup():number  {
    public configureConstellationAsNominalFullOneWebGroup(iG:number):void{
        // OneWeb MM is about 13.21798

        let nPlanes = 12; // 12 Per D. Orr email 3/17/21
        let PlaneSpacingDeg = (360/12)/2; // Equal spacing (15 deg)
        let startRAAN = 0;
        let RAANlist:Array<number> = [];
        for (let iP:number = 0; iP<nPlanes; iP++){
            RAANlist[iP] = startRAAN + iP*PlaneSpacingDeg;
        }
        iG = this.addNewConstellationGroup();
        this.configureConstellationAsOWplanes(iG, RAANlist);
    } 
    //public addEllipticalPlanes(nPlanes:number, nSatellitesPerPlane:number, inclination_deg:number, 
    public configureConstellationAsLEO(iG:number, nPlanes:number, nSatellitesPerPlane:number, inclination_deg:number, apogeeHeight_km:number, perigeeHeight_km:number){
    
        //console.log("In configureConstellationAsLEO, iG = "+iG);
        let i:number = 0;
        this.satelliteParams[iG] = [];   
    
        let MAoffset_deg:number = 0;
        let spacingWithinPlane:number =  360 / nSatellitesPerPlane; 
        let raan:number;  
        let AD = (apogeeHeight_km + UtilSP.earthRadiuskm)*1000; // m
        let PD = (perigeeHeight_km + UtilSP.earthRadiuskm)*1000; // m
        let e:number = (AD - PD)/(AD+PD);
        //let a:number = (AD + PD)/2;
        //let n = Math.sqrt( UtilSP.mu / (a*a*a) );
        // let T:number = UtilSP.circularOrbitRadius2Period(r_km);
        //let T:number = 2 * Math.PI / n; // Period sec
        //let r_km = UtilSP.earthRadiuskm + altitude_km;

        let T:number = UtilSP.apogeeHeightPerigeeHeight2Period(apogeeHeight_km, perigeeHeight_km);
        let MM:number =UtilSP.solarDay_sec / T; // Rev per solar day
        //console.log("altitude_km = "+altitude_km+", T = "+T);
        for (let iP:number = 0; iP<nPlanes; iP++){
            raan = iP * 360 / nPlanes;
            for (let iS = 0; iS<nSatellitesPerPlane; iS++){
                this.satelliteParams[iG][i] = {};
                this.satelliteParams[iG][i].objectName = "LEO"+i;

                this.satelliteParams[iG][i].incl_deg = inclination_deg; //INCLINATION;
                this.satelliteParams[iG][i].e = e; //ECCENTRICITY;
                this.satelliteParams[iG][i].Raan_deg = raan; //RA_OF_ASC_NODE;
                this.satelliteParams[iG][i].AOP_deg = 0; //ARG_OF_PERICENTER;
                this.satelliteParams[iG][i].MAatEpoch_deg = MAoffset_deg + iS * spacingWithinPlane; //MEAN_ANOMALY;
                this.satelliteParams[iG][i].MM_rpd = MM; //MEAN_MOTION;
                this.satelliteParams[iG][i].Te_sec = 0;

                //console.log("Found a valid TLE entry. j = "+j+", name = "+this.satelliteParams[iG][i].objectName+", incl = "+
                    //this.satelliteParams[iG][i].incl_deg);

                this.satelliteParams[iG][i].type = "generic"; 
                this.satelliteParams[iG][i].color = "red"; // Nominal
                this.satelliteParams[iG][i].satSize = 200; // Nominal
                this.satelliteParams[iG][i].blinking = false; // Nominal
                this.satelliteParams[iG][i].visible = true; // Nominal
                this.satelliteParams[iG][i].isGEO = false;  
                i++;
            }
        }    
        console.log("In configureConstellationAsLEO, loading group "+iG+", "+i+" satellites.");
        this.loadGroup(iG);  
    }
    public configureConstellationAsOWplanes(iG:number, RAANlist:Array<number>):void{

        let rwsOW:RandomWithSeed = new RandomWithSeed(0);
        //this._nGroups ++;
        //let iG:number = this._nGroups - 1; // Add to the end
        let i:number = 0;
        this.satelliteParams[iG] = [];

        let nPlanes:number = RAANlist.length;
        console.log("In configureConstellationAsOWplanes, nPlanes = "+nPlanes+", iG = "+iG);

        let nSatellitesPerPlane = 49; // Per D. Orr email 3/17/21
        let inclination = 87.9; // Per D. Orr email 3/17/21 corrected
        let MM = 13.21798; //From Celestrak TLE's. 1 orbit = 1.815 hrs = 109.94 min
        let MAoffset_deg:number;
        let spacingWithinPlane =  360 / nSatellitesPerPlane; 
        let raan:number;  
        for (let iP:number = 0; iP<nPlanes; iP++){
            MAoffset_deg = rwsOW.randRange(0, spacingWithinPlane); // Randomize the phase so the planes are not coherent with each other
            raan = RAANlist[iP];
            for (let iS = 0; iS<nSatellitesPerPlane; iS++){
                this.satelliteParams[iG][i] = {};
                this.satelliteParams[iG][i].objectName = "LEO"+i;
                this.satelliteParams[iG][i].incl_deg = inclination; //INCLINATION;
                this.satelliteParams[iG][i].e = 0; //ECCENTRICITY;
                this.satelliteParams[iG][i].Raan_deg = RAANlist[iP]; //RA_OF_ASC_NODE;
                this.satelliteParams[iG][i].AOP_deg = 0; //ARG_OF_PERICENTER;
                this.satelliteParams[iG][i].MAatEpoch_deg = MAoffset_deg + iS * spacingWithinPlane; //MEAN_ANOMALY;
                this.satelliteParams[iG][i].MM_rpd = MM; //MEAN_MOTION;
                this.satelliteParams[iG][i].Te_sec = 0;
                this.satelliteParams[iG][i].type = "OneWeb"; 
                this.satelliteParams[iG][i].color = "red"; // Nominal
                this.satelliteParams[iG][i].satSize = 200; // Nominal
                this.satelliteParams[iG][i].blinking = false; // Nominal
                this.satelliteParams[iG][i].visible = true; // Nominal
                this.satelliteParams[iG][i].isGEO = false;  
                //console.log("Found a valid TLE entry. j = "+j+", name = "+this.satelliteParams[iG][i].objectName+", incl = "+
                    //this.satelliteParams[iG][i].incl_deg);                
                i++;
            }
        
        }    
        console.log("Loaded group "+iG+", "+i+" satellites.");
        this.loadGroup(iG);  
    }
    public configureConstellationAsOneOWplane(iG:number, nSatellites:number, MAoffset_deg:number, Raan_deg:number):void{
        console.log("In configureConstellationAsOneOWplane, nSatellites = "+nSatellites)
        let i:number = 0;
        this.satelliteParams[iG] = [];

        let nSatellitesPerPlane = 49; // Per D. Orr email 3/17/21
        let inclination = 89.7; // Per D. Orr email 3/17/21
        let MM = 13.21798; //From Celestrak TLE's
        let spacingWithinPlane =  360 / nSatellitesPerPlane;

        for (i = 0; i<nSatellites; i++){
            //console.log("In loop,  iG= "+iG+", nSatellites = "+nSatellites+", i = "+i);
            this.satelliteParams[iG][i] = {};
            this.satelliteParams[iG][i].objectName = "LEO"+i;
            this.satelliteParams[iG][i].incl_deg = inclination; //INCLINATION;
            this.satelliteParams[iG][i].e = 0; //ECCENTRICITY;
            this.satelliteParams[iG][i].Raan_deg = Raan_deg; //RA_OF_ASC_NODE;
            this.satelliteParams[iG][i].AOP_deg = 180; //ARG_OF_PERICENTER;
            this.satelliteParams[iG][i].MAatEpoch_deg = MAoffset_deg + i * spacingWithinPlane; //MEAN_ANOMALY;
            this.satelliteParams[iG][i].MM_rpd = MM; //MEAN_MOTION;
            this.satelliteParams[iG][i].Te_sec = 0;
            this.satelliteParams[iG][i].type = "OneWeb"; 
            this.satelliteParams[iG][i].color = "red"; // Nominal
            this.satelliteParams[iG][i].satSize = 50; // Nominal
            this.satelliteParams[iG][i].blinking = false; // Nominal
            this.satelliteParams[iG][i].visible = true; // Nominal
            this.satelliteParams[iG][i].isGEO = false;  
            //console.log("Found a valid TLE entry. j = "+j+", name = "+this.satelliteParams[iG][i].objectName+", incl = "+
                //this.satelliteParams[iG][i].incl_deg);
        } 
        console.log("Loaded OW plane, iG = "+iG+", "+i+" satellites.");
        this.loadGroup(iG);
    }
    private loadGroup(iG:number){
        // Loads the satObject[iG] array with 3JS objects according to the satelliteParams array.
        // First clear and dispose of the old 3JS objects:
        //console.log("In loadGroup, iG = "+iG);
        let i:number;
        if (!this.satObject || this.satObject.length <= 0){
            this.satObject = [];
        } 
        if (this.satObject[iG]){
            for (i=0; i<this.satObject[iG].length; i++){
                if (this.satObject[iG][i]){
                    this.satObject[iG][i].disposeAll();
                    this.satObject[iG][i].removeFromParent();
                }
            }         
        }
       

        this.satObject[iG] = [];
        for (i = 0; i<this.satelliteParams[iG].length; i++){
            if (this.satelliteParams[iG][i].type == "OneWeb"){
                this.satObject[iG][i] = new OneWebSatellite_grp();
            } else {
                this.satObject[iG][i] = new Satellite3D2_grp();  
                //this.satObject[iG][i] = new Satellite3D_grp();  
            }
            //console.log("Loaded OW sat "+iG+"/"+i+", satelliteStyle = "+this.satObject[iG][i].satelliteStyle)
            this.add(this.satObject[iG][i]);
        }  
        this.updateVisibility();    
        this.updatePositions();            
    }
    private clearGeometriesAndMeshes(){
        // Clear all satellite groups objects.
        let iG:number;
        let i:number;
        for (iG = 0; iG<this.satObject.length; iG++){
            for (i = 0; i<this.satObject[iG].length; i++){
                UtilSP.clearThreeJSGroup(this.satObject[iG][i])
            }
        }
        //this.geometries = [];
        this.satObject = [];    
    }
    /*
    private rebuildMeshes(){
        let iG:number;
        let i:number;
        this.clearGeometriesAndMeshes();
        for (iG = 0; iG<this.satelliteParams.length; iG++){
            //this.geometries[iG] = [];
            this.satObject[iG] = [];
            for (i = 0; i<this.satelliteParams[iG].length; i++){
                this.satObject[iG][i] = new OneWebSatellite_grp();
                this.add(this.satObject[iG][i]);
            }
        }
        this.updateVisibility();    
        this.updatePositions();    
    }
    */

    private createStars(){
        let nStars = 500;
        let star_g:Array<THREE.BoxGeometry>;
        let star_m:Array<THREE.Mesh>;
        let star_mat:THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial( { color: 0x777777 } );
        let starDistance:number = 1e6;
        let rws:RandomWithSeed = new RandomWithSeed(0);
        star_g = [];
        star_m = [];
        for (let i=0; i<nStars; i++){
            let starSize:number = rws.randRange(2000, 5000);
            star_g[i] = new THREE.BoxGeometry(starSize,starSize,starSize);
            star_m[i] = new THREE.Mesh( star_g[i],star_mat );
            let posSh:Spherical = new Spherical(starDistance, rws.randRange(0, Math.PI), rws.randRange(0, 2*Math.PI));
            star_m[i].position.setFromSpherical(posSh);
            this._starsGroup.add(star_m[i]);
        }

    }
    private updatePositions(){
       //console.log("In updatePositions ");
       //debugger
       for (var iG=0; iG <this.satelliteParams.length; iG++ ){
            for (var i=0; i<this.satelliteParams[iG].length; i++){
                //console.log("   iG = "+iG+", i = "+i);
                //if (iG==1) {debugger};
                //console.log("Now _secondsSinceMasterEpoch = "+this._secondsSinceMasterEpoch);
                let satPos:THREE.Vector4 = UtilSP.keplerOrbitTLE_TA( this._secondsSinceMasterEpoch, this.satelliteParams[iG][i]);
                let ta:number = satPos.w;
                let raan:number = this.satelliteParams[iG][i].Raan_deg;
                let incl:number = this.satelliteParams[iG][i].incl_deg;
                this.satObject[iG][i].setPos( satPos.x, satPos.y, satPos.z, ta, this.satelliteParams[iG][i]);
                //console.log("In Constellations3_grp.updatePositions(), iG = "+iG+", i = "+i+", ta = "+ta+", raan = "+raan);
                
                //this.satObject[iG][i].position.x = satPos.x;
                //this.satObject[iG][i].position.y = satPos.y;
                //this.satObject[iG][i].position.z = satPos.z;
                //this.satObject[iG][i].rotation.y = -Math.atan2(satPos.z, satPos.x);
                //this.satObject[iG][i].lookAt(0,0,0); // Keeps Z axis pointed to the center of the earth

                if (iG == 0 && i==0){
                    //console.log(i+" "+UtilSP.vector3toString(this.satObject[iG][i].position));
                    
                   // this.satelliteParams[iG][i].objectName+
                   // ", incl = "+this.satelliteParams[iG][i].incl_deg+
                   // ", Te_sec = "+this.satelliteParams[iG][i].Te_sec);
                }

            }
        }
    }
    private updateVisibility(){
        //debugger
        let vis:boolean = false;
        for (var iG=0; iG <this.satelliteParams.length; iG++ ){
            for (var i=0; i<this.satelliteParams[iG].length; i++){
                if (this.satelliteParams[iG][i].blinking){
                    let t:number = this.blinkTimer.elapsedTime;
                    let v:number = UtilSP.triangleWave2(  t, 1, 0, 100, true ); // t, period, vBottom, vTop, repeating
                    vis = (v<80) && this.satelliteParams[iG][i].visible;
                } else {
                    vis = this.satelliteParams[iG][i].visible;
                }
                this.satObject[iG][i].visible = vis;
            }
        } 
    }
 
    public set secondsSinceMasterEpoch(val){
        // Current time in seconds
        this._secondsSinceMasterEpoch = val;
        //console.log("in set tNow = "+this._secondsSinceMasterEpoch)
        this.updatePositions();
    }
    public get secondsSinceMasterEpoch(){
        return this._secondsSinceMasterEpoch;
    }

    public applyFilter_MaxIncl(iG:number, maxIncl:number){

        for (let i=0; i<this.satelliteParams[iG].length; i++){ 
            if (this.satelliteParams[iG][i].incl_deg > maxIncl){
                this.satelliteParams[iG][i].visible = false;
            }
        }
        this.updateVisibility();
    }
    public getInclinedList(iG:number, minIncl:number, maxIncl:number):Array<number>{
        let list:Array<number>;
        let incl:number;
        list = [];
         for (let i=0; i<this.satelliteParams[iG].length; i++){ 
            incl = this.satelliteParams[iG][i].incl_deg
            //console.log("i = "+i+", incl = "+incl);
            if (incl >= minIncl && incl <= maxIncl){
                list.push(i);
                //console.log("... pushed");
            }
        }  
        return list;     
    }
    public getEllipticalList(iG:number, minE:number, maxE:number):Array<number>{
        let list:Array<number>;
        let e:number;
        list = [];
         for (let i=0; i<this.satelliteParams[iG].length; i++){ 
            e = this.satelliteParams[iG][i].e
            //console.log("i = "+i+", incl = "+incl);
            if (e >= minE && e <= maxE){
                list.push(i);
                //console.log("... pushed");
            }
        }  
        return list;     
    }

    public getNamedList(iG:number, satname:string, ):Array<number>{
        let list:Array<number>;
        let name:string;
        list = [];
         for (let i=0; i<this.satelliteParams[iG].length; i++){ 
            name = this.satelliteParams[iG][i].objectName.toUpperCase();
            //console.log("i = "+i+", incl = "+incl);
            if (name.indexOf(satname.toUpperCase()) >= 0){
                list.push(i);
                //console.log("... pushed");
            }
        }  
        return list;     
    }   
    public showGroup(iG:number, show:boolean, list?:Array<number>){
         // Show or hide whole group
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].visible = show;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satelliteParams[iG][i].visible = show;
            }
        }        
        this.updateVisibility();   
    } 

    public colorGroup(iG:number, color:string, list?:Array<number>){
        // Set color of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satObject[iG][i].color = color;
                //debugger;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satObject[iG][i].color = color;
            }
        }
        //this.rebuildMeshes();
    }
    public inclinationGroup(iG:number, incl:number, list?:Array<number>){
        // Set color of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].incl_deg = incl;
                //debugger;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satelliteParams[iG][i].incl_deg = incl;
            }
        }
    }  
    
    public meanMotionGroup(iG:number, mm:number, list?:Array<number>){
        // Set MM of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].MM_rpd = mm;
                //debugger;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satelliteParams[iG][i].MM_rpd = mm;
            }
        }
    } 
    public eccentricityGroup(iG:number, e:number, list?:Array<number>){
        // Set MM of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].e = e;
                //debugger;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satelliteParams[iG][i].e = e;
            }
        }
    }     
    public RAANGroup(iG:number, raan:number, list?:Array<number>){
        // Set color of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].Raan_deg = raan;
                //debugger;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satelliteParams[iG][i].Raan_deg = raan;
            }
        }
    } 
    public styleGroup(iG:number, style:string, list?:Array<number>){
        // Set style of all sats in group n. Default all, or just the indices in list
        //console.log("In styleGroup iG = "+iG+", style = "+style+", list = "+list);
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].satelliteStyle = style;
                //debugger;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satObject[iG][i].satelliteStyle = style;
            }
        }
        //this.rebuildMeshes();
    }
    public sizeGroup(iG:number, size:number, list?:Array<number>){
        // Set size of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satObject[iG][i].satelliteSize = size;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satObject[iG][i].satelliteSize = size;
            }
        }
    }
    
    public displayScaleGroup(iG:number, size:number, list?:Array<number>){
        // Set satelliteDisplayScale of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satObject[iG][i].satelliteDisplayScale = size;
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satObject[iG][i].satelliteDisplayScale = size;
            }
        }
    }

    public showAntennasGroup(iG:number, showAnts:boolean, list?:Array<number>){
        // Set size of all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satObject[iG][i].showAntennas = showAnts;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satObject[iG][i].showAntennas = showAnts;
            }
        }
    }

    public blinkGroup(iG:number, blink:boolean, list?:Array<number>){
        // Set blinking = true for all sats in group n. Default all, or just the indices in list
        let i:number;
        let k:number;
        if (list){
            for (k=0; k<list.length; k++){
                i = list[k];
                this.satelliteParams[iG][i].blinking = blink;
                //console.log("k = "+k+", i = "+i);
            }
        } else {
            for (i=0; i<this.satelliteParams[iG].length; i++){ 
                this.satelliteParams[iG][i].blinking = blink;
            }
        }
        this.updateVisibility();   
    }
    public set showStars(val:boolean){
        this._starsGroup.visible = val;
    }
    public get showStars(){
        return this._starsGroup.visible;
    }
    public doEveryFrame(){
        //console.log("In constellations3_grp.doEveryFrame");
        this.updateVisibility();
    }
    public setObjectType(iG, val:string){
        //this.clearGeometriesAndMeshes();
        this.objectType[iG] = val;
        //this.rebuildMeshes();
    }
    public setOrbitPlaneDisc(incl:number, raan:number, radius:number){
        this.orbitPlaneDisc1.rotation.x = UtilSP.radians(incl); // Fixed incl for Cosmos3 2/23/22
        this.orbitPlaneDisc2.rotation.y = UtilSP.radians(raan);
        this.orbitPlaneDisc_m.scale.x = radius/10000;
        this.orbitPlaneDisc_m.scale.y = radius/10000;
        this.orbitPlaneDisc_m.scale.z = radius/10000;

    } 
    public set showOrbitPlaneDisc(val:boolean){
        this.orbitPlaneDisc_m.visible = val;
    }
    public set showCosmicPlane(val:boolean){
        this.cosmicPlane_m.visible = val;
    }    
    public set showCosmicAxes(val:boolean){
        this.cosmicAxes.visible = val;
    }
    public getGEOlongitude(group:number, satIndex:number):number{
        if (this.satelliteParams[group][satIndex].isGEO){
            return this.satelliteParams[group][satIndex].GEOlongitude
        } else {
            console.log("In getGEOlongitude, group = "+group+", satIndex = "+satIndex+", ERROR: isGEO is false or does not exist");
            return NaN;
        }
    }
    public getNSatsInGroup(group:number):number{
        return this.satelliteParams[group].length;
    }
}


